import React from "react";
import { SimpleCircleNode } from "../types";

type SimpleCircleProps = {
  node: SimpleCircleNode;
};

export const SimpleCircle = ({ node }: SimpleCircleProps) => {
  return (
    <circle
      id={node.id}
      cx={node.x}
      cy={node.y}
      r={node.size}
      fill={node.color}
      stroke={node.strokeColor}
      strokeWidth={node.strokeWidth}
      paintOrder={"stroke"}
      opacity={node.opacity}
      style={{ cursor: "pointer" }}
      onMouseEnter={(e) => {
        e.currentTarget.style.opacity = "1";
        e.currentTarget.style.filter = "brightness(1.2)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.opacity = node.opacity?.toString() || "1";
        e.currentTarget.style.filter = "none";
      }}
    >
      {node.title && <title>{node.title}</title>}
    </circle>
  );
};
